import { NumberInput, TextInput } from 'react-admin';
import React from 'react';

export const AddressInputs = () => {
  return (
    <>
      <TextInput label={'Name'} required fullWidth source={'address.name'} />
      <TextInput
        label={'Street'}
        required
        fullWidth
        source={'address.street'}
      />
      <TextInput
        label={'Number'}
        required
        fullWidth
        source={'address.number'}
      />
      <TextInput label={'City'} required fullWidth source={'address.city'} />
      <TextInput
        label={'Zipcode'}
        required
        fullWidth
        source={'address.zipcode'}
      />
      <TextInput label={'Phone'} required fullWidth source={'address.phone'} />
      <TextInput label={'Fax'} required fullWidth source={'address.fax'} />
      <TextInput label={'Email'} required fullWidth source={'address.email'} />
      <TextInput
        label={'OpeningHours'}
        fullWidth
        source={'address.openingHours'}
      />
      <NumberInput label={'Latitude'} fullWidth source={'address.latitude'} />
      <NumberInput label={'Longitude'} fullWidth source={'address.longitude'} />
    </>
  );
};
